import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const SvgI24Filter = props => {
  return (
    <SvgIcon {...props}>
      <path d="M15 19.88C15.04 20.18 14.94 20.5 14.71 20.71C14.32 21.1 13.69 21.1 13.3 20.71L9.28998 16.7C9.05998 16.47 8.95998 16.16 8.99998 15.87V10.75L4.20998 4.62C3.86998 4.19 3.94998 3.56 4.37998 3.22C4.56998 3.08 4.77998 3 4.99998 3H19C19.22 3 19.43 3.08 19.62 3.22C20.05 3.56 20.13 4.19 19.79 4.62L15 10.75V19.88ZM7.03998 5L11 10.06V15.58L13 17.58V10.05L16.96 5H7.03998Z" />
    </SvgIcon>
  );
};

export default SvgI24Filter;
